module.exports = __webpack_public_path__ + "img/11.ac08fcd8.png";